import { FormEvent, useEffect, useState } from "react";
import { apiRequest } from "../api";
import { useAuth } from "../auth";

export function SettingsPage() {
  const { businessId, business, refreshBusinesses } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);
  const [form, setForm] = useState({
    name: "",
    description: "",
    phoneNumber: "",
    email: "",
    addressLine1: "",
    city: "",
    region: "",
    postalCode: "",
    country: "US",
    timezone: "America/New_York",
    primaryColor: "#0F766E",
    secondaryColor: "#134E4A",
    heroHeadline: "",
    callToAction: "Book a Service",
    aboutContent: "",
  });

  useEffect(() => {
    if (!business) return;
    setForm({
      name: business.name ?? "",
      description: business.description ?? "",
      phoneNumber: business.phoneNumber ?? "",
      email: business.email ?? "",
      addressLine1: business.addressLine1 ?? "",
      city: business.city ?? "",
      region: business.region ?? "",
      postalCode: business.postalCode ?? "",
      country: business.country ?? "US",
      timezone: business.timezone ?? "America/New_York",
      primaryColor: business.primaryColor ?? "#0F766E",
      secondaryColor: business.secondaryColor ?? "#134E4A",
      heroHeadline: business.heroHeadline ?? "",
      callToAction: business.callToAction ?? "Book a Service",
      aboutContent: business.aboutContent ?? "",
    });
  }, [business]);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    if (!businessId) return;
    setPending(true);
    setError(null);
    try {
      await apiRequest(`/businesses/${businessId}`, {
        method: "PATCH",
        body: JSON.stringify(form),
      });
      await refreshBusinesses();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Save failed");
    } finally {
      setPending(false);
    }
  }

  if (!businessId)
    return (
      <section>
        <p className="notice">No business selected.</p>
      </section>
    );

  return (
    <>
      <header className="page-header">
        <div>
          <p className="eyebrow">Settings</p>
          <h1>Business profile</h1>
        </div>
      </header>

      <section>
        <form className="form-grid" onSubmit={onSubmit}>
          <label>
            Business name
            <input
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />
          </label>
          <label>
            Description
            <textarea
              value={form.description}
              onChange={(e) =>
                setForm({ ...form, description: e.target.value })
              }
            />
          </label>
          <div className="form-grid two">
            <label>
              Phone
              <input
                value={form.phoneNumber}
                onChange={(e) =>
                  setForm({ ...form, phoneNumber: e.target.value })
                }
              />
            </label>
            <label>
              Email
              <input
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
              />
            </label>
          </div>
          <label>
            Address
            <input
              value={form.addressLine1}
              onChange={(e) =>
                setForm({ ...form, addressLine1: e.target.value })
              }
            />
          </label>
          <div className="form-grid two">
            <label>
              City
              <input
                value={form.city}
                onChange={(e) => setForm({ ...form, city: e.target.value })}
              />
            </label>
            <label>
              Region
              <input
                value={form.region}
                onChange={(e) => setForm({ ...form, region: e.target.value })}
              />
            </label>
          </div>
          <div className="form-grid two">
            <label>
              Postal code
              <input
                value={form.postalCode}
                onChange={(e) =>
                  setForm({ ...form, postalCode: e.target.value })
                }
              />
            </label>
            <label>
              Country
              <input
                maxLength={2}
                value={form.country}
                onChange={(e) =>
                  setForm({ ...form, country: e.target.value.toUpperCase() })
                }
              />
            </label>
          </div>
          <div className="form-grid two">
            <label>
              Primary color
              <input
                value={form.primaryColor}
                onChange={(e) =>
                  setForm({ ...form, primaryColor: e.target.value })
                }
              />
            </label>
            <label>
              Secondary color
              <input
                value={form.secondaryColor}
                onChange={(e) =>
                  setForm({ ...form, secondaryColor: e.target.value })
                }
              />
            </label>
          </div>
          <label>
            Hero headline
            <input
              value={form.heroHeadline}
              onChange={(e) =>
                setForm({ ...form, heroHeadline: e.target.value })
              }
            />
          </label>
          <label>
            Call to action
            <input
              value={form.callToAction}
              onChange={(e) =>
                setForm({ ...form, callToAction: e.target.value })
              }
            />
          </label>
          <label>
            About content
            <textarea
              value={form.aboutContent}
              onChange={(e) =>
                setForm({ ...form, aboutContent: e.target.value })
              }
            />
          </label>
          <button className="btn btn-primary" type="submit" disabled={pending}>
            {pending ? "Saving..." : "Save settings"}
          </button>
          {error ? <p className="notice error">{error}</p> : null}
        </form>
      </section>
    </>
  );
}
